<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closeOnEscape]="!varianteInCorso"
  [dismissableMask]="!varianteInCorso"
  [style]="{width: '60vw', height: '75vh'}"
  styleClass="p-fluid variante-dialog"
  [showHeader]="false"
  (onHide)="hide()">

  <div class="dialog-container" style="height: 100%; display: flex; flex-direction: column;">
    <!-- Header del dialog -->
    <div class="dialog-header">
      <div class="header-content">
        <span class="material-icons" style="font-size: 28px; margin-right: 8px;">edit_document</span>
        <h3>Variante della richiesta per il {{richiesta?.anno}} dell'ente {{richiesta?.enteEsecutore?.label | uppercase}}</h3>
      </div>
      <button
        pButton
        pRipple
        icon="pi pi-times"
        class="p-button-rounded p-button-text close-btn"
        [disabled]="varianteInCorso"
        (click)="hide()">
      </button>
    </div>

    <!-- Contenuto principale -->
    <div class="dialog-content" style="flex: 1; overflow-y: auto;" *ngIf="richiesta">
            <div class="flex justify-content-between align-items-center mb-3">
        <div class="search-container">
          <div class="custom-search-input">
            <i class="pi pi-search search-icon" [ngClass]="{'hidden': filtroTestoGlobale.length > 0}"></i>
            <input
              type="text"
              pInputText
              [(ngModel)]="filtroTestoGlobale"
              (input)="onFiltroGlobaleChange($event)"
              placeholder="Cerca"
              class="search-input"
            />
            <i class="pi pi-times clear-icon" *ngIf="filtroTestoGlobale.length > 0" (click)="pulisciFiltroGlobale()" style="cursor: pointer;"></i>
          </div>
        </div>

        <button class="action-button"
            style="background-color: #a0cccc; color: #333; border: 1px solid #A0D6C1; box-shadow: 0 2px 4px rgba(0,0,0,0.1); border-radius: 6px; cursor: pointer;"
                (click)="aggiungiIntervento()"
              >
              <span class="material-icons" style="margin-right: 8px;">add</span>
              Aggiungi
        </button>
      </div>
      <p-table
            #dt
            [value]="interventi"
            styleClass="p-datatable-sm p-datatable-gridlines"
            [globalFilterFields]="['scheda.codice', 'scheda.vecchioCodiceUmvs', 'importoRichiesto', 'importoRimodulato', 'importoFinanziato']"
            [sortMode]="'multiple'"
            [multiSortMeta]="[{field: 'scheda.codice', order: -1}, {field: 'importoRichiesto', order: 1}]"
            [showInitialSortBadge]="false"
            responsiveLayout="stack"
            [rowHover]="true"
            [loading]="!interventiCaricati"
            [scrollable]="true"
            [tableStyle]="{'min-width': '50rem'}"
            [showCurrentPageReport]="true"
            dataKey="id"

            >
            <ng-template pTemplate="header">
              <tr>
                <th style="text-align: center;" [pSortableColumn]="'scheda.codice'">Codice</th>
                <th style="text-align: center;" [pSortableColumn]="'scheda.vecchioCodiceUmvs'">Vecchio codice</th>
                <th style="text-align: center;">Importo richiesto</th>
                <th style="text-align: center;">Importo rimodulato</th>
                <th style="text-align: center;">Importo finanziato</th>
                <th style="text-align: center;">Azioni</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-intervento>
              <tr>
                <td>
                  <div class="codice-scheda-badge">
                    <span class="codice-scheda-value">
                      {{ intervento.scheda.codice | uppercase}}
                    </span>
                  </div>
                </td>
                <td>
                  <div class="codice-scheda-badge" *ngIf="intervento.scheda.vecchioCodiceUmvs !== null">
                    <span class="codice-scheda-value" >
                      {{ intervento.scheda.vecchioCodiceUmvs | uppercase}}
                    </span>
                  </div>
                </td>
                <td style="text-align: center;">{{intervento.importoRichiesto | currency:'EUR':'symbol':'1.2-2':'it-IT'}}</td>
                <td style="text-align: center;">{{intervento.importoRimodulato | currency:'EUR':'symbol':'1.2-2':'it-IT'}}</td>
                <td style="text-align: center;">
                  <ng-container *ngIf="interventoInModifica?.id !== intervento.id; else editMode">
                    {{intervento.importoFinanziato | currency:'EUR':'symbol':'1.2-2':'it-IT'}}
                  </ng-container>
                  <ng-template #editMode>
                    <p-inputNumber
                      [(ngModel)]="nuovoImportoFinanziato"
                      mode="currency"
                      currency="EUR"
                      locale="it-IT"
                      [min]="0"
                      styleClass="w-full"
                      (onBlur)="salvaModificaImporto(intervento)"
                      (keydown.enter)="salvaModificaImporto(intervento)"
                      (keydown.tab)="salvaModificaImporto(intervento)"
                      (onInput)="onInputChange($event.value)">
                    </p-inputNumber>
                  </ng-template>
                </td>
                <td style="text-align: center;">
                  <ng-container *ngIf="interventoInModifica?.id !== intervento.id; else confermaButton">
                    <div class="flex gap-2">
                      <button
                        pButton
                        pRipple
                        icon="pi pi-pencil"
                        class="p-button-rounded p-button-text"
                        (click)="modificaImportoFinanziato(intervento)"
                        pTooltip="Modifica l'importo finanziato"
                        tooltipPosition="top">
                      </button>
                      <button
                        pButton
                        pRipple
                        icon="pi pi-minus-circle"
                        class="p-button-rounded p-button-text p-button-danger"
                        (click)="azzeraImportoFinanziato(intervento)"
                        pTooltip="Azzera l'importo finanziato"
                        tooltipPosition="top">
                      </button>
                    </div>
                  </ng-container>
                  <ng-template #confermaButton>
                    <button
                      pButton
                      pRipple
                      icon="pi pi-check"
                      class="p-button-rounded p-button-text p-button-success"
                      (click)="salvaModificaImporto(intervento)">
                    </button>
                  </ng-template>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="footer">
              <tr>
                <td colspan="4" style="text-align: right; font-weight: bold;">Totale Importo Finanziato:</td>
                <td style="text-align: center; font-weight: bold;">{{ getTotaleImportiFinanziati() | currency:'EUR':'symbol':'1.2-2':'it-IT' }}</td>
                <td></td>
              </tr>
            </ng-template>
        </p-table>
     <!--  <div class="warning-message">
        <i class="pi pi-exclamation-triangle warning-icon"></i>
        <div class="warning-content">
          <h3>Attenzione</h3>
          <p>Stai per creare una variante della richiesta {{richiesta.anno}}.</p>
          <p>Questa operazione non potrà essere annullata</p>
        </div>
      </div> -->

      <!--<div class="richiesta-info">


        <p-divider></p-divider>
         <div class="info-row">
          <div class="info-label">Ente:</div>
          <div class="info-value">
            <span class="material-symbols-outlined"
              [style.color]="stiliService.getColoreIconaEnteEsecutore(richiesta.enteEsecutore)"
              style="vertical-align: middle; margin-right: 8px;">
              {{ stiliService.getMaterialIconEnteEsecutore(richiesta.enteEsecutore) }}
            </span>
            {{ richiesta.enteEsecutore.label }}
          </div>
        </div>

        <div class="info-row">
          <div class="info-label">Anno:</div>
          <div class="info-value">{{ richiesta.anno }}</div>
        </div>

        <div class="info-row">
          <div class="info-label">Importo richiesto:</div>
          <div class="info-value importo">{{ richiesta.importoRichiesto | currency:'EUR':'symbol':'1.2-2':'it-IT' }}</div>
        </div>

        <div class="info-row">
          <div class="info-label">Importo contributo:</div>
          <div class="info-value importo">{{ richiesta.importoContributo | currency:'EUR':'symbol':'1.2-2':'it-IT' }}</div>
        </div>
        <div class="info-row">
          <div class="info-label">Importo rimodulato:</div>
          <div class="info-value importo">{{ richiesta.importoRimodulato | currency:'EUR':'symbol':'1.2-2':'it-IT' }}</div>
        </div>
      </div>-->
    </div>

    <!-- Footer del dialog -->
    <div class="dialog-footer">
      <button
        pButton
        pRipple
        label="Annulla"
        icon="pi pi-times"
        class="p-button-text"
        [disabled]="varianteInCorso"
        (click)="hide()">
      </button>
      <button
        pButton
        pRipple
        label="Conferma"
        icon="pi pi-check"
        class="p-button-success"
        [loading]="varianteInCorso"
        [disabled]="varianteInCorso || interventoInModifica !== null"
        (click)="creaVariante()">
      </button>
    </div>
  </div>
</p-dialog>


<!-- Toast per notifiche -->
<p-toast position="top-right"></p-toast>

<app-aggiungi-intervento *ngIf="richiesta" [richiesta]="richiesta" (interventoAggiunto)="onInterventoAggiunto($event)"></app-aggiungi-intervento>
